import { render } from "./headerTop.vue?vue&type=template&id=3a702771&scoped=true"
const script = {}

import "./headerTop.vue?vue&type=style&index=0&id=3a702771&scoped=true&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a702771"]])

export default __exports__